function addNotifications(current, newNotifications) {
  return newNotifications
    .reduce((acc, notification) => {
      // skip duplicate notifications, notifications are duplicates if they have the same slug
      if (acc.find((n) => n.slug === notification.slug)) {
        return acc;
      }

      return acc.concat(notification);
    }, current)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}

function groupNotifications(notifications) {
  return notifications.reduce((acc, notification) => {
    const brandName = notification.brand.name;
    let brandNotifications = acc.find((brand) => brand.name === brandName);

    if (brandNotifications === undefined) {
      brandNotifications = {
        name: brandName,
        notifications: [],
        unreadCount: 0,
      };
      acc.push(brandNotifications);
    }

    brandNotifications.notifications.push(notification);
    brandNotifications.unreadCount += notification.isRead ? 0 : 1;

    return acc;
  }, []);
}

function isUpdated(current, newNotifications) {
  return newNotifications.length > current.length;
}

function unreadCount(notifications) {
  return notifications.filter((notification) => !notification.isRead).length;
}

export function reducer(state, action) {
  let notifications;

  switch (action.type) {
    case 'ADD_NOTIFICATIONS':
      notifications = addNotifications(
        state.notifications,
        Array.isArray(action.payload) ? action.payload : [action.payload]
      );

      return {
        ...state,
        notifications,
        lastUpdate: isUpdated(state.notifications, notifications)
          ? Date.now()
          : state.lastUpdate,
        groupedNotifications: groupNotifications(notifications),
        unreadCount: unreadCount(notifications),
      };
    case 'UPDATE_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.payload,
        groupedNotifications: groupNotifications(action.payload),
        lastUpdate: isUpdated(state.notifications, action.payload)
          ? Date.now()
          : state.lastUpdate,
        unreadCount: unreadCount(action.payload),
      };
    case 'RESET':
      return {
        notifications: [],
        groupedNotifications: [],
        lastUpdate: Date.now(),
        unreadCount: 0,
      };
    default:
      throw new Error(`Reducer: no case for "${action.type}"`);
  }
}
